import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { logout } from '../../actions/index';
import $ from 'jquery';
import {
  Nav,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  Breadcrumb,
  BreadcrumbItem
} from 'reactstrap';
import HeaderDropdown from './HeaderDropdown';

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      navigate: false,
      path:"",
      uploadModalOpen:false,
      editShotModalOpen:false,
      activeTab:'1'
    }
    this.logOut = this.logOut.bind(this);
    this.globalAjaxError = this.globalAjaxError.bind(this);

    $(document).on("ajaxError", this.globalAjaxError);
  }

  globalAjaxError(event, xhr, settings, thrownError) {
    if (xhr.status == 401) {
      event.preventDefault();
      this.logOut();
      $.ajaxSettings.global = false;
      setTimeout(function(){ $.ajaxSettings.global = true; }, 3000);
    }
  }

  logOut() {
    this.props.dispatch(logout());
    this.setState({
      navigate: true,
      path:"login",
    })

  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  render() {

    const { navigate, path } = this.state

    // here is the important part
    if (navigate) {
      console.log("navigate to [" + path + "]");
      return <Redirect to={ "/" + path } push={true} />
    }

    return (
      <header className="app-header navbar">
        <NavbarBrand href="#"></NavbarBrand>
        <NavbarToggler className="d-md-down-none" onClick={this.sidebarToggle}>
        </NavbarToggler>
        <Nav className="d-md-down-none" navbar>
          <NavItem className="px-1">
            Customer  /
          </NavItem>
           <NavItem className="px-1">
           { this.props.user.username }
          </NavItem>
        </Nav>

        <Nav className="ml-auto" navbar>
          <NavItem className="px-3">
            <NavLink href="/#/Account">Accounts </NavLink>
          </NavItem>
          <NavItem className="px-3">
            <NavLink onClick = {()=> this.logOut()}> Log out </NavLink>
          </NavItem>
          <HeaderDropdown accnt/>
        </Nav>

      </header>
    );
  }
}


function mapStateToProps(state) {
    return {
        user: state.activeUser,
    };
}


export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js